import React from 'react';
import SaveIcon from "@mui/icons-material/Save";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

export default function ClientInfo({
  isOpen,
  onToggle,
  tempNom,
  setTempNom,
  tempEmail,
  setTempEmail,
  tempTel,
  setTempTel,
  hasChanges,
  onSave
}) {
  return (
    <>
      <div className="accordion-header" onClick={onToggle}>
        <span className="accordion-title">
          <i className="pi pi-user"></i> Informations client
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {hasChanges && (
            <span
              onClick={(e) => {
                e.stopPropagation();
                onSave();
              }}
              style={{
                borderRadius: "4px",
                color: "#fff",
                width: "22px",
                height: "22px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                backgroundColor: "#322915",
              }}
            >
              <SaveIcon sx={{ fontSize: 13 }} />
            </span>
          )}
          {isOpen ? (
            <ExpandLessIcon sx={{ fontSize: 18, color: "#6b7280" }} />
          ) : (
            <ExpandMoreIcon sx={{ fontSize: 18, color: "#6b7280" }} />
          )}
        </div>
      </div>

      {isOpen && (
        <div className="grid mb-3">
          <div className="col-12 md:col-4">
            <label className="field-label">Nom</label>
            <input
              className="clean-input"
              value={tempNom}
              onChange={(e) => setTempNom(e.target.value)}
            />
          </div>
          <div className="col-12 md:col-4">
            <label className="field-label">Email</label>
            <input
              className="clean-input"
              value={tempEmail}
              onChange={(e) => setTempEmail(e.target.value)}
            />
          </div>
          <div className="col-12 md:col-4">
            <label className="field-label">Téléphone</label>
            <input
              className="clean-input"
              value={tempTel}
              onChange={(e) => setTempTel(e.target.value)}
            />
          </div>
        </div>
      )}
    </>
  );
}